var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For-Brock---FINAL-Whole-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Practitioner_statistic",
    transform: "translate(-341, -497)",
    fill: "#61849D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(341, 497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9452161,7.55775998 C20.8077464,7.13516868 20.430586,6.83502379 19.9843703,6.79505754 L13.9232076,6.24810917 L11.5264607,0.67305699 C11.3497369,0.264477802 10.9472616,1.44817079e-16 10.5000846,1.44817079e-16 C10.0529076,1.44817079e-16 9.65043231,0.264477802 9.47370847,0.674012378 L7.07696161,6.24810917 L1.01483756,6.79505754 C0.569422973,6.83597914 0.193223962,7.13516868 0.0549531754,7.55775998 C-0.0833176109,7.98035123 0.0443785648,8.44386413 0.381323467,8.73604764 L4.96284473,12.729169 L3.61186074,18.6433769 C3.51300436,19.0782288 3.68283864,19.5277296 4.04589958,19.7885451 C4.24104886,19.9286658 4.46936386,20 4.69960152,20 C4.89811542,20 5.0950271,19.9468178 5.27175094,19.8417273 L10.5000846,16.7363024 L15.7264956,19.8417273 C16.1089433,20.0703788 16.5910485,20.0495199 16.9533083,19.7885451 C17.3165295,19.5269334 17.4862035,19.0772734 17.3873471,18.6433769 L16.0363632,12.729169 L20.6178844,8.73684377 C20.9548293,8.44386413 21.0834868,7.98114736 20.9452161,7.55775998 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStar);
export default __webpack_public_path__ + "static/media/fullStar.ece022269a41f20929d002f8dd612cf3.svg";
export { ForwardRef as ReactComponent };